import { Menu, MenuItem, styled } from "@mui/material";
import { FC, useState } from "react";

import { IconChevronDown, IconMoreHoriz } from "@/assets/icons";
import { Button } from "@/components/elements/Button";
import { text } from "@/theme/colors";
import { rounded } from "@/theme/variables";

type TRelatedActionsMenuProps = {
  /** 削除 is disabled until at least one deletable product is selected. */
  disableDelete: boolean;
  onDelete: () => void;
};

/** 関連操作 dropdown — currently exposes 削除 (delete selected products). */
export const RelatedActionsMenu: FC<TRelatedActionsMenuProps> = ({ disableDelete, onDelete }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (e: React.MouseEvent<HTMLButtonElement>) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleDelete = () => {
    handleClose();
    onDelete();
  };

  return (
    <>
      <Button variant="outline" size="md" onClick={handleOpen} startIcon={<IconMoreHoriz />} endIcon={<IconChevronDown />}>
        関連操作
      </Button>
      <StyledMenu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <DangerMenuItem disabled={disableDelete} onClick={handleDelete}>
          削除
        </DangerMenuItem>
      </StyledMenu>
    </>
  );
};

const StyledMenu = styled(Menu)`
  .MuiPaper-root {
    min-width: 180px;
    border-radius: ${rounded.sm};
    margin-top: 4px;
  }
`;

const DangerMenuItem = styled(MenuItem)`
  color: ${text.error};
  font-size: 14px;
  padding: 12px 16px;
  &.Mui-disabled {
    color: ${text.disable};
  }
`;
